/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { FolderPath } from 'cio/components/asset-library';

const MAX_LIMIT_BREADCRUMBS = 4;

interface AssetLibraryToolbarFolderNavigationArgs {
  currentFolder: FolderPath;
  folderPaths: FolderPath[];
  onSelectFolder: (folderId: string | null) => unknown;
  onDrop: (folder: FolderPath) => unknown;
}

export default class AssetLibraryToolbarFolderNavigation extends Component<AssetLibraryToolbarFolderNavigationArgs> {
  get isCondensed() {
    return this.args.folderPaths.length > MAX_LIMIT_BREADCRUMBS;
  }

  get rootFolderPath() {
    return this.args.folderPaths[0];
  }

  get condensedFolderPaths() {
    let condensedPaths: FolderPath[] = [];

    if (!this.isCondensed) {
      return condensedPaths;
    }

    return this.args.folderPaths.slice(1, this.args.folderPaths.length - 2);
  }

  get visibleFolderPaths() {
    if (this.args.folderPaths.length < 2) {
      return [];
    }

    return this.args.folderPaths.slice(this.isCondensed ? -2 : 1);
  }

  @action
  onSelectFolderPath(folderPath: FolderPath) {
    this.args.onSelectFolder(folderPath.id);
  }
}
